import ApiService from "./api.service";
const InspectionBookNewService = {
  GetList(data) {
    return ApiService.post(`/InspectionBookNew/GetList`, data);
  },
  Get(id) {
    if (id == 0 || id == undefined || id == null || id == "") {
      return ApiService.get(`/InspectionBookNew/Get`);
    } else {
      return ApiService.get(`/InspectionBookNew/Get/${id}`);
    }
  },
  Create(data) {
    return ApiService.post(`/InspectionBookNew/Create`, data);
  },
  Update(data) {
    return ApiService.post(`/InspectionBookNew/Update`, data);
  },
  Save(data) {
    if (data.id == 0 || data.id == undefined || data.id == null) {
      return ApiService.post(`/InspectionBookNew/Create`, data);
    } else {
      return ApiService.post(`/InspectionBookNew/Update`, data);
    }
  },
  Send(data) {
    return ApiService.post(`/InspectionBookNew/Send`, data);
  },
  GetHistoryList(inspectionBookId, data) {
    return ApiService.post(
      `/InspectionBookNew/GetHistoryList/${inspectionBookId}`,
      data
    );
  },
  SaveAsExecel(data) {
    return ApiService.printtemp(`/InspectionBookNew/SaveAsExecel`, data);
  },
  GetSecurityInfo() {
    return ApiService.get(`/InspectionBookNew/GetSecurityInfo`);
  },
};
export default InspectionBookNewService;
